import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import useMousePosition from '@/hooks/useMousePosition/useMousePosition';
import clsx from 'clsx';
import React from 'react';
import styles from './BaseToolTip.module.scss';
import BaseToolTipMobile from './BaseToolTipMobile/BaseToolTipMobile';
import type { BaseToolTipProps } from './interfaces';

const BaseToolTip = ({
  title,
  children,
  showTooltip = true,
  variant = 'default',
  mobileComponentSlot = (
    <BaseToolTipMobile isVisible={showTooltip}>Kopiert!</BaseToolTipMobile>
  ),
}: BaseToolTipProps) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const isMobile = useIsMobile(768);
  const { x, y } = useMousePosition();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const childrenComponent = React.cloneElement(children, {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
  });

  return (
    <React.Fragment>
      {childrenComponent}
      {isMobile ? (
        mobileComponentSlot
      ) : (
        <div
          className={styles.base}
          style={{
            left: x ?? 0,
            top: (y ?? 0) + 32,
          }}
        >
          <div
            className={clsx(styles.popper, styles[variant], {
              [styles.show]: showTooltip && isHovered,
            })}
          >
            {title}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default BaseToolTip;
